import axios, { AxiosError, AxiosRequestConfig } from "axios";
import { CheckInResponseType, CheckInType } from "../interfaces/interfaces";
import { format, parseISO } from "date-fns";
const printProto = require("./PrintDataPb");

export const itemTypes = [{
    code: "STR",
    label: "Stroller",
    value: "STR"
}, {
    code: "BAG",
    label: "Baggage",
    value: "BAG"
}]

export function classNames(...classes: any) {
    return classes.filter(Boolean).join(" ");
}

export function isUserAuthenticated(): boolean {
    if (sessionStorage.getItem("auth_code")) {
        return true;
    } else {
        return false;
    }
}

export function getHCPApiInstance() {
    const controller = new AbortController();
    const payload = {
        baseURL: process.env.GATSBY_HCP_API_URL,
        signal: controller.signal,
        headers: {
            "Content-Type": "application/json",
            "x-api-key": process.env.GATSBY_HCP_API_KEY,
        },
        timeout: 10000,
    } as AxiosRequestConfig<any>;
    const instance = axios.create(payload);
    return { instance, controller };
}

export function getOpenApiInstance(code: string | null) {
    const controller = new AbortController();
    const payload = {
        baseURL: process.env.GATSBY_OPEN_API_URL,
        signal: controller.signal,
    } as AxiosRequestConfig<any>;
    const token = code || sessionStorage.getItem("auth_code");
    if (token) {
        payload.headers = {
            authorization: "Bearer " + token,
        };
    }
    const instance = axios.create(payload);
    return { instance, controller };
}

export function getApiInstance() {
    const controller = new AbortController();
    const payload = {
        baseURL: process.env.GATSBY_API_URL,
        signal: controller.signal,
    } as AxiosRequestConfig<any>;
    const token = sessionStorage.getItem("auth_code");
    if (token) {
        // jika ada token di session
        payload.headers = {
            authorization: "Bearer " + token,
        };
    }
    const instance = axios.create(payload);
    return { instance, controller };
}

export function getOperatorApiInstance() {
    const controller = new AbortController();
    const payload = {
        baseURL: process.env.GATSBY_API_URL + "/operator",
        signal: controller.signal,
    } as AxiosRequestConfig<any>;
    const token = sessionStorage.getItem("operator_token");
    if (token) {
        // jika ada token di session
        payload.headers = {
            authorization: "Bearer " + token,
        };
    }
    const instance = axios.create(payload);
    return { instance, controller };
}

export function parseJwt(token: string) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
}

export function isOperatorAuthenticated(): boolean {
    if (sessionStorage.getItem("operator_token")) {
        return true;
    } else {
        return false;
    }
}

export const getFormattedName = (name: string) => {
    // ambil 2 kata pertama saja
    const tempName = name.split(" ");
    if (tempName.length > 2) {
        name = tempName[0] + " " + tempName[1];
    } // kalau 2 karakter, tidak perlu di update
    return name;
};

export const processPrinters = (data: string) => {
    var tempArray = data.split(",").map((o) => +o);
    var tempBuffer = new Uint8Array(tempArray);
    const message = printProto.AvailablePrinters.deserializeBinary(tempBuffer);
    const printers = message.getPrintersList();
    return printers;
}

const messageText = (text: string, size: number, x: number, y: number) => {
    const message = new printProto.PrintRawData();
    message.setContent(text);
    message.setType(printProto.PrintRawData.Type.TEXT);
    message.setSize(size);
    message.setX(x);
    message.setY(y);
    return message
}

const messageQrCode = (text: string, size: number, x: number, y: number) => {
    const message = new printProto.PrintRawData();
    message.setContent(text);
    message.setType(printProto.PrintRawData.Type.QRCODE);
    message.setSize(size);
    message.setX(x);
    message.setY(y);
    message.setEec("M");
    return message
}

export const selfTicketToProto = (data: CheckInResponseType) => {
    // grouping ke array
    const messages = new printProto.CustomPrintData();
    messages.addLines(messageText(getFormattedName(data.person_name), 2, 15, 50))
    messages.addLines(messageText(data.code, 3, 15, 125))
    // kalau ada notes
    if (data.notes) {
        messages.addLines(messageText(data.notes, 1, 15, 200))
    }
    // tanggal cetak
    const datetime = formatDateTime(data.created_at, "d MMM yy, HH:mm");
    messages.addLines(messageText(`${datetime} - ${data.service_over_at.substring(0, 5)}`, 1, 15, 275))
    // qrcode
    messages.addLines(messageQrCode(data.group_id, 5, 420, 225))
    // serialize data
    var bytes = messages.serializeBinary();
    let stringBuffer = Array.prototype.toString.call(bytes);
    return stringBuffer;
}

export const userTicketToProto = (data: CheckInResponseType) => {
    // grouping ke array
    const messages = new printProto.CustomPrintData();
    messages.addLines(messageText(getFormattedName(data.person_name), 2, 15, 50))
    messages.addLines(messageText(data.room_name, 1, 15, 110))
    messages.addLines(messageText(data.code, 3, 15, 150))
    // kalau ada notes
    if (data.notes) {
        messages.addLines(messageText(data.notes, 1, 15, 225))
    }
    // tanggal cetak
    const datetime = formatDateTime(data.created_at, "d MMM yy, HH:mm");
    messages.addLines(messageText(`${datetime} - ${data.service_over_at.substring(0, 5)}`, 1, 15, 275))
    // serialize data
    var bytes = messages.serializeBinary();
    let stringBuffer = Array.prototype.toString.call(bytes);
    return stringBuffer;
}

export const formatDateTime = (val: string, dateFormat = "d MMM yyyy HH:mm") => {
    return format(parseISO(val), dateFormat);
};

